export default __webpack_public_path__ + "static/media/favicon.e5f351c4.ico";